import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Form, InputGroup } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Calendar } from "primereact/calendar";
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import config from '../config';
function Edit_employee_leave({ requestData, onSuccess }) {
    const { accessToken } = useAuth();
    const [leaveBalances, setLeaveBalances] = useState([]);
    const [leaveSplits, setLeaveSplits] = useState([]);
    const [error, setError] = useState(null);
    const parsedDates = JSON.parse(requestData.dates); // Parse JSON string to array


    // Fetch leave balances
    useEffect(() => {
        const fetchLeaveBalances = async () => {
            try {
                const response = await axios.get(
                    `${config.apiBASEURL}/leaveRoutes/fetch-user-leave-balances/${requestData.user_id}`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                setLeaveBalances(response.data.data);
            } catch (err) {
                console.error("Error fetching leave balances:", err);
            }
        };
        fetchLeaveBalances();
    }, [requestData.user_id, accessToken]);


    // Date filter to disable Sundays and past dates
    const dateFilter = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const isSunday = date.getDay() === 0;

        return !isSunday;
    };


    // Add a new split
    const addSplit = () => {
        setLeaveSplits((prevSplits) => [
            ...prevSplits,
            { leave_type_id: "", total_days: 0, dates: [] },
        ]);
    };

    // Handle split changes
    const handleSplitChange = (index, field, value) => {
        const updatedSplits = [...leaveSplits];
        updatedSplits[index][field] = value;

        // Calculate total days when dates are updated
        if (field === "dates") {
            updatedSplits[index].total_days = value.length;
        }
        setLeaveSplits(updatedSplits);
    };

    // Remove a split
    const removeSplit = (index) => {
        const updatedSplits = leaveSplits.filter((_, i) => i !== index);
        setLeaveSplits(updatedSplits);
    };

    // Validate and submit the form
    const handleSubmit = async () => {
        setError(null);

        const totalSplitDays = leaveSplits.reduce(
            (sum, split) => sum + split.total_days,
            0
        );

        // Validate total days
        if (totalSplitDays > requestData.Total_days) {
            setError("Total days of splits cannot exceed the requested total days.");
            return;
        }
        // Validate total days
        if (totalSplitDays < requestData.Total_days) {
            setError("Total days of splits cannot be less than the requested total days.");
            return;
        }

        for (const split of leaveSplits) {
            const leaveBalance = leaveBalances.find(
                (balance) => balance.leave_type_id === split.leave_type_id
            );

            // Validate individual split balance
            if (!leaveBalance) {
                setError(`Leave type ${split.leave_type_id} not found.`);
                return;
            }
            if (split.total_days > leaveBalance.earned_days) {
                setError(
                    `Insufficient balance for leave type: <strong>${leaveBalance.name}</strong>.`
                );
                return;
            }
        }

        // Submit data
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/leaveRoutes/split-leave-request`,
                {
                    leave_request_id: requestData.Leave_request_id,
                    splits: leaveSplits.map((split) => ({
                        Leave_type_Id: split.leave_type_id,
                        total_days: split.total_days,
                        dates: split.dates.map((date) =>
                            new Date(date).toISOString().split('T')[0] // Format to YYYY-MM-DD
                        ),
                    })),
                },
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            if (response.status === 200) {
                onSuccess(); // Refresh leave requests
            }
        } catch (err) {
            console.error("Error submitting leave splits:", err);
        }
    };



    return (
        <>
            <div className="mb-4">
                <ul className="splitLeave">
                    <li className="w-100">
                        <img
                            src={
                                requestData.requestor.profileImage?.image_url ||
                                require('../assets/images/no_user.png')
                            }
                            alt=""
                            style={{ width: '35px', height: '35px' }}
                            className="rounded-circle me-2"
                        />
                    </li>
                    <li>
                        <small>Employee Name</small>
                        <span> {`${requestData.requestor.first_name} ${requestData.requestor.last_name}`}</span>
                    </li>
                    <li>
                        <small>Leave Type</small>
                        <span> {requestData.leaveType.name}</span>
                    </li>
                    <li>
                        <small>Total Days</small>
                        <span>{requestData.Total_days} Days</span>
                    </li>
                    {/* <li>
                        <small>Requested Dates</small>
                        <span> {parsedDates.map((date, index) => (
                            <small key={index} className='alldateSpan'>
                                {new Date(date).toLocaleDateString("en-GB")}
                            </small>
                        ))}</span>
                    </li> */}
                    <li>
                        <small>Issued On</small>
                        <span>{new Date(requestData.createdAt).toLocaleDateString("en-GB")}</span>
                    </li>
                </ul>
            </div>
            <div className="position-relative">

                {error && (
                    <div style={{fontSize:'12px', padding:'5px 10px'}} className="alert alert-danger text-center" dangerouslySetInnerHTML={{ __html: error }} />
                )}
                {leaveSplits.map((split, index) => (
                    <div key={index} className="mb-3   rounded">
                        <Form.Group>
                            <Form.Label className="d-flex justify-content-between">
                                Selected Leave Type
                                <Button
                                    tite="Remove"
                                    icon="pi pi-trash"
                                    className="py-2 p-0 border-0"
                                    severity="danger"
                                    outlined

                                    onClick={() => removeSplit(index)}
                                /></Form.Label>
                            <Form.Select
                                value={split.leave_type_id}
                                onChange={(e) =>
                                    handleSplitChange(index, "leave_type_id", Number(e.target.value))
                                }
                            >
                                <option value="" disabled>
                                    Select Leave Type
                                </option>
                                {leaveBalances.map((balance) => (
                                    <option key={balance.leave_type_id} value={balance.leave_type_id}>
                                        {`${balance.name} (Available: ${balance.earned_days} days)`}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mt-1">

                            <Calendar
                                value={split.dates}
                                onChange={(e) => handleSplitChange(index, "dates", e.value)}
                                selectionMode="multiple"
                                // minDate={new Date()}
                                dateFormat="dd/mm/yy"
                                placeholder="Select Leave Dates"
                                disabledDates={[]}
                                disabledDays={[0]} // Sundays

                                className="h-auto w-100 custom-calendar"
                                filterDate={dateFilter} // Custom date filter
                            />
                        </Form.Group>



                    </div>
                ))}
                <div className="d-flex justify-content-end">
                    <Button label="Split" icon="pi pi-plus" className="mt-0 py-2" onClick={addSplit} />
                    <Button
                        label="Submit"
                        icon="pi pi-check"
                        className="mt-0 ms-3 py-2"
                        onClick={handleSubmit}
                        severity="success"
                    />
                </div>
            </div>
        </>
    );
}

export default Edit_employee_leave;